import { render, staticRenderFns } from "./RequirementCard.vue?vue&type=template&id=9f0965e0&"
import script from "./RequirementCard.vue?vue&type=script&lang=js&"
export * from "./RequirementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports